/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 9/2/2023
 */

import BaseObject from "@shared/BaseObject";

export default class RedirectData extends BaseObject {

	isEnabled: boolean = false

	url: string = null


	constructor(url) {
		super();
		this.url = url || null
	}
}
